export { default } from './PageSettings';
